import React, {Component} from 'react';
import {message, Modal, Slider, Spin} from "antd";
import videojs from "video.js";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import Titlepicfile from "../../../components/titlepicfile/Titlepicfile";

export default class VideoCapture extends BaseComponent {
    static defaultProps = {
        videoAll: [],
        onOk: () => {
        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            videoVisible: false,
            videoImg: '',
            currentTime: 1,//视频取桢数
            checkedVideo: props.videoAll && props.videoAll[0] && props.videoAll[0].src ? props.videoAll[0].src : '',
            checkedKey: 0,
            videoAll: props.videoAll,
            videoStatus: true,
        };
    }

    componentWillMount() {
        // if (this.state.checkedVideo) {
        //     this.getVideoBase64(this.state.checkedVideo,this.props.videoAll[0].videoWidth,this.props.videoAll[0].videoHeight).then(res => {
        //         this.setState({videoImg: res})
        //     });
        // }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // if (nextProps.videoAll && nextProps.videoAll.length) {
            this.state.videoAll = nextProps.videoAll || [];
            this.state.checkedKey = 0;
            this.state.checkedVideo = nextProps.videoAll?.[0]?.src || "";
            // this.getVideoBase64(this.state.checkedVideo,nextProps.videoAll[0].videoWidth,nextProps.videoAll[0].videoHeight).then(res => {
            //     this.setState({videoImg: res})
            // });
        // }
    }

    render() {
        const {videoVisible} = this.state;
        const {videoAll} = this.props;
        // if (!(this.props.videoAll && this.props.videoAll.length)){
        //     // message.destroy();
        //     // message.error('未查找到视频！');
        //     return <></>
        // }
        //过滤外链地址
        // let newVideoList =  videoAll&&videoAll.filter(item=>!item.src.match(/(http|https):\/\/\S*/) )
        // // 去重
        // let obj = {};
        // newVideoList && newVideoList.forEach(item => obj[item.videoSrc] = item );
        let newVideoAll = videoAll || [];
        // for (let key in obj) {
        //     newVideoAll.push(obj[key])
        // }
        return (
            <>
                <Modal
                    title={'视频截取'}
                    centered
                    width={800}
                    visible={videoVisible}
                    onOk={() => {
                        let file = this.getBlobBydataURI(this.state.videoImg, 'image/jpeg');
                        this.convertVideoPic(file)
                    }}
                    className={'videoCapture'}
                    onCancel={this.handleCancelVideo}
                    bodyStyle={{height: 370}}
                >
                    {
                        this.props?.videoAll?.length ? (
                            <div style={{display: 'flex'}}>
                                <div style={{
                                    // width: 225,
                                    height: 370,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'start',
                                    borderRight: '2px solid #dbdbdb',
                                    padding: '24px 20px 24px 32px',
                                }}>

                                    <Scrollbars style={{paddingLeft: 5, width: 170}} autoHide>
                                        {
                                            newVideoAll && newVideoAll.map((item, index) => {
                                                return (
                                                    <img src={item.videoSrc} key={index} style={{
                                                        width: 160,
                                                        height: 90,
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                        marginBottom: '24px',
                                                        border: '3px solid',
                                                        borderColor: this.state.checkedKey == index?'#0050B3': 'transparent',
                                                        objectFit: 'cover'
                                                    }} onClick={(e) => {
                                                        this.setState({videoStatus: true,}, () => {
                                                            this.itemVideoScreenClick(item, index);
                                                        });
                                                    }}/>
                                                )
                                            })
                                        }
                                    </Scrollbars>
                                </div>
                                {/*{*/}
                                {/*    this.state.videoStatus ?*/}

                                {/*:*/}
                                <div style={{padding: '24px 47px',position: 'relative'}}>
                                    <Spin size={'large'} spinning={this.state.videoStatus} style={{
                                        display: 'flex',
                                        width: 480,
                                        height: 270,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'absolute',
                                        zIndex:2,
                                    }}/>
                                    <Titlepicfile src={this.state.videoImg}
                                                  style={{width: 480, height: 270}}/>
                                    {/*视频取桢进度条*/}
                                    <div style={{
                                        width: 480,
                                        height: 56,
                                        // background: 'rgba(0,0,0,0.45)',
                                        textAlign: 'center'
                                    }}>
                                        <div style={{display: 'flex', paddingLeft: 5, paddingTop: 13}}>
                                            {/*<img style={{width: 9, height: 13, paddingTop: 5}} src={playPic}/>*/}
                                            <p style={{fontSize: 14}}>拖动视频帧数截取</p>
                                            {/*<div style={{color: 'white', marginLeft: 275}}>*/}
                                            {/*    <span>{moment(currentTime * 1000).format('mm:ss')}</span>/<span>{moment(this.props.videoAll[0].duration).format('mm:ss')}</span>*/}
                                            {/*</div>*/}
                                        </div>
                                        <div style={{marginTop: -16}}>
                                            <Slider
                                                value={this.state.currentTime}
                                                min={1}
                                                style={{width: '100%'}}
                                                disabled={this.state.videoStatus}
                                                max={parseInt(this.timeCycle(this.state.videoAll[this.state.checkedKey].duration))}
                                                onChange={(value) => {
                                                    // console.log("value",value,this.player)
                                                    this.setState({
                                                        currentTime: value,
                                                        videoStatus: true
                                                    }, () => {
                                                        this.getVideoBase64(this.state.checkedVideo, this.state.videoAll[this.state.checkedKey].videoWidth, this.state.videoAll[this.state.checkedKey].videoHeight).then(res => {
                                                            this.setState({videoImg: res,videoStatus:false})
                                                        })
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                // }

                            </div>
                        ) : ""
                    }
                    <style>
                        {`
                    .videoCapture .ant-modal-body{
                      padding:0px !important;
                    }
                    .videoCapture .ant-slider-track{
                      background-color:#0050B3;
                    }
                    `}
                    </style>
                </Modal>
                <div style={{display:'none'}}>
                    <video id={'myVideo'}/>
                    <canvas id={'myCanvas'}/>
                </div>
            </>
        )
    }

    getVideoWidthHeight(fileUrl, callback) {
            const videoObj = document.getElementById("myVideo");
            // videoObj.preload = "metadata";
            videoObj.src = fileUrl;
            videoObj.onloadedmetadata = function (evt) {
                // URL.revokeObjectURL(fileUrl);
                let videoTime = videoObj.duration; // 获取视频的时长
                let width = videoObj.videoWidth; //获取视频的宽
                let height = videoObj.videoHeight; //获取视频的高
                callback({width, height});
            };
    };

    // 视频截取取消
    handleCancelVideo = () => {
        this.setState({videoVisible: false});
    };
    // 显示
    showModal = () => {
        if(this.state?.videoAll?.[0]) {
            this.setState({videoVisible: true, videoStatus: true,}, () => {
                this.itemVideoScreenClick(this.state.videoAll[0], 0)
            });
        }
    };
    // 视频截取
    handleVideo = () => {
        this.setState({
            videoVisible: true
        })
    };
    timeCycle = (time) => {
        if (time) {
            return time / 1000
        }
    };
    //视频封面取桢
    getVideoBase64 = (url,width,height) => {
        let {currentTime} = this.state;
        return new Promise(function (resolve, reject) {
            let dataURL = '';
            let video = document.getElementById("myVideo");
            video.setAttribute('crossorigin', 'anonymous'); //处理跨域
            video.setAttribute('src', url);
            // video.setAttribute('width', width);
            // video.setAttribute('height', height);
            // video.setAttribute('controls', 'controls');
            video.currentTime = currentTime;  //视频时长，一定要设置，不然大概率白屏
            video.onloadeddata=function (e) {
                let canvas = document.getElementById("myCanvas"),
                    width = e.target.videoWidth, //canvas的尺寸和图片一样
                    height = e.target.videoHeight;
                canvas.width = width;
                canvas.height = height;
                canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
                dataURL = canvas.toDataURL('image/png'); //转换为base64
                resolve(dataURL);

                // var img = document.createElement("img");
                // img.src = dataURL;
                // video.setAttribute('poster', dataURL);
            };

        })
    };

    getBlobBydataURI(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: type});
        // var formData = new FormData();
        // // var frameCurrentTime = videoFrameCollect.getFrameCurrentTime();
        // // var $Blob = getBlobBydataURI(videoFrameCollect.getFrameUrl(),'image/jpeg');
        // // var isDouyin = localStorage.getItem("isDouyin")
        // formData.append(dataURI);
    }

    //视频帧封面图接口
    convertVideoPic = (file) => {
        var formData = new FormData();
        formData.append('file', file, '未命名.png');
        this.request({
            url: "/storage/uploadFile",
            method: 'POST',
            body: formData,
            contentType: 'upload',
            callBack: (res) => {
                if (res) {
                    this.props.getVideoPicture && this.props.getVideoPicture(res.path);
                    this.setState({videoVisible: false,})
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    itemVideoScreenClick(item, index) {
        // this.getVideoWidthHeight(item.src, (data) => {
        //     this.state.videoAll[index].videoWidth = data.width;
        //     this.state.videoAll[index].videoHeight = data.height;
            this.state.currentTime = 1;
            this.state.checkedKey = index;
            this.getVideoBase64(item.src, null, null).then(res => {
                this.setState({
                    checkedVideo: item.src,
                    videoImg: res,
                    videoStatus: false
                })
            });
        // });
    }
}